import cn from "classnames";

export const Count = ({ n }: { n: number | null }) => (
  <span
    className={cn(
      "inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-semibold leading-none flex-none order-1 grow-0",
      n !== null && n > 0
        ? "bg-indigo-200 text-black-700"
        : "bg-black-100 text-black-500",
    )}
  >
    {n === null ? "-" : n}
  </span>
);
